import axios from 'axios'
import { versions } from '@/common/util.js'
const channel = 11
const instance = axios.create({
  baseURL: process.env.VUE_APP_BASEURL,
  withCredentials: true
})
// axios.defaults.withCredentials = true;
//基地址
// axios.defaults.baseURL = process.env.VUE_APP_BASEURL;

instance.interceptors.request.use(function (config) {
  config.headers.s = "h5";
  let token = localStorage.getItem("token");
  if(token){
    config.headers.token = token;
    if(config.data) {
      config.data['token'] = token;
    }
  }
  if(config.data && !config.data['channel']) {
    config.data['channel'] = channel
  }
  return config;
}, function (error) {
  console.error("req:" + error);
  return Promise.reject(error);
});



//通用方法
export const POST = (url, params) => {
  return instance.post(url, params).then(res => res.data)
    .catch(error => {
      console.log(error);
    })
}

export const GET = (url, params) => {
  return instance.get(url, {params: params}).then(res => res.data)
    .catch(error => {
      console.log(error);
    })
}

export const PUT = (url, params) => {
  return instance.put(url, params).then(res => res.data)
    .catch(error => {
      console.log(error);
    })
}

export const DELETE = (url, params) => {
  return instance.delete(url, {params: params}).then(res => res.data)
    .catch(error => {
      console.log(error);
    })
}

export const PATCH = (url, params) => {
  return instance.patch(url, params).then(res => res.data)
    .catch(error => {
      console.log(error);
    })
}

export const AXIOS = (url, params,headers = { 'Content-Type': 'application/json' }) => {
  return instance.post(url, params, headers).then(res => res.data)
    .catch(error => {
      console.log(error);
    })
}
/*export const AXIOS = (url, data, headers = { 'Content-Type': 'application/json' }) => {
  return axios.request({
    url,
    method: 'post',
    data,
    headers
  });
}*/

export default {
  AXIOS,
  POST,
  GET,
  PUT,
  DELETE,
  PATCH,
}
